module.exports = __webpack_public_path__ + "fonts/TelefonicaText.c3ca2f54.woff";